import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";

const sections = [
  { to: "/settings/clinic", title: "Dados e módulos" },
  { to: "/my-business", title: "Visão geral" },
  { to: "/my-business/strategy", title: "Estratégia" },
];

export function ClinicNavigation() {
  return (
    <nav aria-label="Seções da clínica" className="flex flex-wrap gap-1 border-b border-app-border pb-3">
      {sections.map(({ to, title }) => (
        <NavLink key={to} to={to} end className={({ isActive }) => cn(
          "inline-flex min-h-11 items-center rounded-lg px-4 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand",
          isActive ? "bg-brand-soft font-medium text-brand" : "text-app-fg-muted hover:bg-app-surface-muted"
        )}>{title}</NavLink>
      ))}
    </nav>
  );
}
